import { render } from "./UnsentInvoicesDetails.vue?vue&type=template&id=166525dc"
import script from "./UnsentInvoicesDetails.vue?vue&type=script&lang=js"
export * from "./UnsentInvoicesDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__